"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _DriversItem = require("./DriversItem");

var _DriversItem2 = _interopRequireDefault(_DriversItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DriversList = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DriversList, _Component);

  function DriversList() {
    (0, _classCallCheck3.default)(this, DriversList);
    return (0, _possibleConstructorReturn3.default)(this, (DriversList.__proto__ || (0, _getPrototypeOf2.default)(DriversList)).apply(this, arguments));
  }

  (0, _createClass3.default)(DriversList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      console.info("adDriversList", this.props.adDriversList);
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.licensedDriversList || !this.props.licensedDriversList.length) {
        return this.renderEmptyMessage();
      }
      return this.renderList();
    }
  }, {
    key: "renderEmptyMessage",
    value: function renderEmptyMessage() {
      return _react2.default.createElement(
        "div",
        { className: "voucher-order-cart" },
        _react2.default.createElement(
          "p",
          null,
          "Yrityksell\xE4 ei ole lisensoutuja kuljettajia."
        )
      );
    }
  }, {
    key: "isInDriversList",
    value: function isInDriversList(email) {
      var emailExists = false;
      if (this.props.adDriversList) {
        this.props.adDriversList.forEach(function (data) {
          if (data.email == email) {
            emailExists = true;
          }
        });
      }
      return emailExists;
    }
  }, {
    key: "renderList",
    value: function renderList() {
      return _react2.default.createElement(
        "table",
        { className: "table voucher-order-cart" },
        _react2.default.createElement(
          "thead",
          null,
          _react2.default.createElement(
            "tr",
            null,
            _react2.default.createElement(
              "th",
              null,
              "Ilmoituksen kuljettaja:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "Nimi:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "Puhelin:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "S\xE4hk\xF6posti:"
            ),
            _react2.default.createElement(
              "th",
              null,
              "Yritys:"
            ),
            _react2.default.createElement("th", null)
          )
        ),
        _react2.default.createElement(
          "tbody",
          null,
          this.renderItems()
        )
      );
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      if (!this.props.licensedDriversList || !this.props.licensedDriversList.length) {
        return null;
      }

      return this.props.licensedDriversList.map(function (item, index) {
        var newItem = item;
        newItem.is_active = _this2.isInDriversList(newItem.email);
        if (!item.user_id) {
          return null;
        }
        return _react2.default.createElement(_DriversItem2.default, {
          key: index,
          item: newItem,
          addDriver: _this2.props.addDriver,
          removeDriver: _this2.props.removeDriver,
          updateDriverByEmail: _this2.props.updateDriverByEmail,
          projectId: _this2.props.projectId
        });
      });
    }
  }]);
  return DriversList;
}(_react.Component), _class.propTypes = {
  licensedDriversList: _react.PropTypes.array,
  adDriversList: _react.PropTypes.array,
  updateDriverByEmail: _react.PropTypes.func,
  addDriver: _react.PropTypes.func,
  removeDriver: _react.PropTypes.func
}, _temp);
exports.default = DriversList;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/projects/DriversList.js
 ** module id = 482
 ** module chunks = 0
 **/